export default function MetricCard({ label, value, sub, accent, icon, onClick }) {
  return (
    <div
      onClick={onClick}
      className={`flex-1 min-w-[170px] p-5 bg-white rounded-xl border border-gray-200 shadow-sm ${
        onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''
      }`}
    >
      <div className="flex justify-between items-start">
        <div>
          <div className="text-[11px] text-gray-400 font-semibold tracking-wide uppercase mb-1.5">
            {label}
          </div>
          <div className="text-2xl font-extrabold tracking-tight" style={{ color: accent || '#1E293B' }}>
            {value}
          </div>
        </div>
        {icon && <span className="text-xl opacity-50">{icon}</span>}
      </div>
      {sub && <div className="text-[11px] text-gray-400 mt-1">{sub}</div>}
    </div>
  );
}
